import React from 'react';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { KatSpinner } from '@amzn/katal-react';
import { Init } from 'src/config/Auth';

import './i18n';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import store from './store/store';

// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.

Init();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <AppInitWrapper>
          <React.Suspense fallback={<KatSpinner size="large" />}>
            <App />
          </React.Suspense>
        </AppInitWrapper>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);
